import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class InAppMessageService {
  constructor(
    private toastController: ToastController,
    private translate: TranslateService,
    private alertController: AlertController
  ) { }

  async simpleToast(
    message: string,
    translate = true,
    position: 'top' | 'middle' | 'bottom' = 'middle',
    duration: number = 3000
  ) {
    if (translate) {
      message = this.translate.instant(message);
    }
    const toast = await this.toastController.create({
      message,
      duration,
      position,
      keyboardClose: true,
      cssClass: 'simple-toast',
      color: 'medium'
    });

    return toast.present();
  }

  async simpleAlert(
    header: string,
    message: string,
    okText: string = this.translate.instant('common.ok'),
    backdropDismiss = false,
    handler = () => { }
  ) {
    const alert = await this.alertController.create({
      header,
      message,
      backdropDismiss,
      buttons: [{
        text: okText,
        handler,
      }]
    });

    return alert.present();
  }
}
